export const GET_NOTIFICATION_REQUEST = "GET_NOTIFICATION_REQUEST"
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS"
export const GET_NOTIFICATION_FAIL = "GET_NOTIFICATION_FAIL"

export const UPDATE_NOTIFICATION_REQUEST = "UPDATE_NOTIFICATION_REQUEST"
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS"
export const UPDATE_NOTIFICATION_FAIL = "UPDATE_NOTIFICATION_FAIL"

export const UPDATE_ALL_NOTIFICATION_REQUEST = "UPDATE_ALL_NOTIFICATION_REQUEST"

export const TEMP_DATA_FOR_NOTIFICATION = "TEMP_DATA_FOR_NOTIFICATION"
export const TEMP_DATA_FOR_NOTIFICATION_RESET = "TEMP_DATA_FOR_NOTIFICATION_RESET"

export const GET_UNREAD_NOTIFICATION_REQUEST = "GET_UNREAD_NOTIFICATION_REQUEST"
export const GET_UNREAD_NOTIFICATION_SUCCESS = "GET_UNREAD_NOTIFICATION_SUCCESS"
export const GET_UNREAD_NOTIFICATION_FAIL = "GET_UNREAD_NOTIFICATION_FAIL"

export const GET_LATEST_UNREAD_NOTIFICATION_REQUEST = "GET_LATEST_UNREAD_NOTIFICATION_REQUEST"
export const GET_LATEST_UNREAD_NOTIFICATION_SUCCESS = "GET_LATEST_UNREAD_NOTIFICATION_SUCCESS"
export const GET_LATEST_UNREAD_NOTIFICATION_FAIL = "GET_LATEST_UNREAD_NOTIFICATION_FAIL"
export const GET_LATEST_UNREAD_NOTIFICATION_RESET = "GET_LATEST_UNREAD_NOTIFICATION_RESET"